import React from 'react'
import { NavLink, Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { HiOutlineMenuAlt2 } from 'react-icons/hi'
import {
  DashboardBikes,
  DashboardCompany,
  DashboardFeed,
  DashboardLogo,
  DashboardLogout,
  DashboardOrder,
  DashboardSettings,
  DashboardZone,
} from '../../../../assets/icons'
import { logout } from '../../../../store/actions'
import { Button } from '../../../../UI'
import pickOrder from '../../../../assets/pickOrder.svg'
import Container from './styles'

const SideNav = ({ showNav }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  return (
    <Container onClick={showNav}>
      <div className="sideNav--content" onClick={(e) => e.stopPropagation()}>
        <header>
          <Button icon className="toggleMenu--btn" onClick={showNav}>
            <HiOutlineMenuAlt2 />
          </Button>
          <Link to="/">
            <img src={pickOrder} alt="Pick Order" style={{ width: 100 }} />
          </Link>

        </header>
        <nav>
          <div>
            <NavLink to="/dashboard" exact={true}>
              <DashboardLogo />
              Dashboard
            </NavLink>
            <NavLink to="/dashboard/admins">
              <DashboardSettings />
              Admins
            </NavLink>
            <NavLink to="/dashboard/companies">
              <DashboardCompany />
              Companies
            </NavLink>
            <NavLink to="/dashboard/orders">
              <DashboardOrder />
              Orders
            </NavLink>
            <NavLink to="/dashboard/audit-logs">
              <DashboardFeed />
              Audit Logs
            </NavLink>
            <NavLink to="/dashboard/zone">
              <DashboardZone />
              Zone
            </NavLink>
            <NavLink to="/dashboard/bikes">
              <DashboardBikes />
              Riders
            </NavLink>
          </div>
          <div className="nav--footer">
            <Button
              full
              onClick={() => {
                dispatch(logout(navigate))
              }}
            >
              <DashboardLogout />
              Log out
            </Button>
          </div>
        </nav>
      </div>
    </Container>
  )
}

export default SideNav
